module.exports = __webpack_public_path__ + "af3c611b31f7a69d220ab5c70818b866.png";